import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: `https://api.hhesport.dk`,
    withCredentials: false,
    headers: {
      //'Authorization': 'Bearer '+localStorage.token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}
